'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('shareimg', {
        url: '/shareimg',
        template: '<shareimg></shareimg>'
    });
}



// WEBPACK FOOTER //
// ./client/app/shareimg/shareimg.routes.js